import { render, staticRenderFns } from "./CountriesForm.vue?vue&type=template&id=6b641f7d&scoped=true&"
import script from "./CountriesForm.vue?vue&type=script&lang=js&"
export * from "./CountriesForm.vue?vue&type=script&lang=js&"
import style0 from "./CountriesForm.vue?vue&type=style&index=0&id=6b641f7d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b641f7d",
  null
  
)

export default component.exports